import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { PosChangePriceModalService } from 'src/app/@core/services/pos-change-price-modal.service';
import { PosChangePriceModalComponent } from './pos-change-price-modal.component';



@NgModule({
  declarations: [PosChangePriceModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxMaskModule
  ],
  providers: [PosChangePriceModalService],
  exports: [PosChangePriceModalComponent]
})
export class PosChangePriceModalModule { }
